import { render, staticRenderFns } from "./ProgrammeSubjectGroupSave.vue?vue&type=template&id=6bce3898&"
import script from "./ProgrammeSubjectGroupSave.vue?vue&type=script&lang=js&"
export * from "./ProgrammeSubjectGroupSave.vue?vue&type=script&lang=js&"
import style0 from "./ProgrammeSubjectGroupSave.vue?vue&type=style&index=0&id=6bce3898&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports